import React from 'react';
import { default as List } from '@material-ui/core/List';

import { default as Collapse } from '@material-ui/core/Collapse';
import { IReport, IReportEntity } from '../../../state/types';
import VisualHint from '../../VisualHint';

interface IReportProps {
    open: boolean;
    report: IReport;
    visualHint: boolean;
    renderListItem: (
        entity: IReportEntity,
        openDeletionDialog: (id: string, message?: string | undefined) => void,
        borderLess?: boolean
    ) => React.ReactNode;
    openDeletionDialog: (id: string, message?: string | undefined) => void;
}

type TProps = IReportProps;

const ReportEntitiesList: React.FC<TProps> = ({
    open,
    report,
    visualHint,
    renderListItem,
    openDeletionDialog,
}: TProps) => {
    const weHaveEntities = report.entities?.length > 0;
    const headerless = report._meta?.headerless || false;

    return (
        <>
            {weHaveEntities && visualHint && (
                <Collapse in={open} timeout="auto" unmountOnExit={true}>
                    <VisualHint entities={report.entities} />
                </Collapse>
            )}
            {weHaveEntities && !visualHint && (
                <Collapse in={open} timeout="auto" unmountOnExit={true}>
                    <List component="div" disablePadding={true} dense={true}>
                        {report.entities.map((entity: any, index: number) => (
                            <React.Fragment key={entity.id || entity.label}>
                                {renderListItem(
                                    entity,
                                    openDeletionDialog,
                                    index == 0 && headerless
                                )}
                            </React.Fragment>
                        ))}
                    </List>
                </Collapse>
            )}
        </>
    );
};

export default ReportEntitiesList;
